import { Quote } from "lucide-react";

const testimonials = [
    {
        name: "Distribuidora Nacional de Suministros",
        role: "Cliente de mayoreo",
        quote:
            "Como su principal cliente de mayoreo, valoramos la eficiencia en sus procesos de comercialización masiva; su stock constante de artículos de oficina es el motor de nuestra red de redistribución.",
    },
    {
        name: "Consorcio Educativo del Norte",
        role: "15 sedes educativas",
        quote:
            "Delegar el abasto de papelería de nuestras 15 sedes en Opteris fue un acierto; sus procesos de distribución corporativa garantizan que nunca nos falten consumibles críticos.",
    },
    {
        name: "Corporativo Jurídico Asociados",
        role: "Despacho profesional",
        quote:
            "Gracias a su gestión de ventas corporativas, centralizamos todo nuestro equipamiento de oficina con un solo proveedor, optimizando nuestros tiempos de compra y logística interna.",
    },
    {
        name: "Dra. Mariana Solís",
        role: "Cliente Particular",
        quote:
            "Incluso en compras al por menor, la atención técnica y la variedad de productos de papelería que ofrecen es superior a cualquier otra tienda; siempre encuentro lo que busco.",
    },
];

export default function Testimonials() {
    return (
        <section
            id="testimonios"
            data-testid="testimonials-section"
            className="py-20 lg:py-32 opteris-soft-bg relative overflow-hidden"
        >
            <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full bg-[#ea4d87]/5 blur-3xl pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="max-w-3xl fade-up">
                    <span className="opteris-chip">Testimonios</span>
                    <h2
                        data-testid="testimonials-heading"
                        className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 leading-[1.1]"
                    >
                        Lo que dicen nuestros{" "}
                        <span className="opteris-gradient-text">
                            clientes
                        </span>
                    </h2>
                </div>

                <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
                    {testimonials.map((t, i) => (
                        <div
                            key={i}
                            data-testid={`testimonial-card-${i}`}
                            className="opteris-card p-8 lg:p-10 relative fade-up"
                        >
                            <Quote
                                className="absolute top-6 right-6 text-[#f49c8b]/40"
                                size={48}
                                strokeWidth={1.5}
                            />
                            <p className="text-gray-700 leading-relaxed text-base relative z-10">
                                &ldquo;{t.quote}&rdquo;
                            </p>
                            <div className="mt-6 pt-6 border-t border-gray-100">
                                <div
                                    data-testid={`testimonial-name-${i}`}
                                    className="font-display font-bold text-[#ea4d87]"
                                >
                                    {t.name}
                                </div>
                                <div className="text-xs text-gray-500 mt-1 uppercase tracking-wider font-medium">
                                    {t.role}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
